module.exports = __webpack_public_path__ + "images/assets/96b3e01102cbe5590e284629522c0851.svg";